import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/minbzk.webp';
import screenshot_target from '../../../images/letterfunnel/petergiskes.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Peter Giskes"
      firstname="Peter"
      companyname="Min BZK"
      competition="DICTU en CIO Rijk"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/petergiskes.js